import { Grid } from "@mui/material";
import MxFormL3SelectTrustField from "@rf-l3/form/MxFormL3SelectTrustField";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";

const HasMeetingsTrustEntity = () => {
  return (
    <Grid container item xs={12} rowGap={2}>
      <Grid item xs={12}>
        <MxFormL3SelectTrustField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.trust_entity_has_meeting_trustee}
          label="Nombre de fiduciaria"
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3InputField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.trust_oficial_name_meeting_trustee}
          label="Nombre de ejecutivo"
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.trust_date_meeting_trustee}
          label="Fecha de la reunión"
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3TextAreaField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.trust_notes_trustee}
          label="Notas de la reunión"
        />
      </Grid>
    </Grid>
  );
};

export default HasMeetingsTrustEntity;
